<div class="p-5">
  <fgbcl-loading></fgbcl-loading>
</div>
